import { call, put } from "redux-saga/effects";

// Api
import { editTransactionHistory } from "../../../api";

// Actions
import { authActions } from "../../../actions/auth";
import { uploadSelectionActions } from "../../../actions/uploadSelection";

export function* addProductMemory({ payload: { token, data, cb } }) {
  try {
    yield put(authActions.startLoading());

    const { response } = yield call(editTransactionHistory, token, data);

    yield put(authActions.finishLoading());

    if (response) {
      // dispatch state update
      yield put(uploadSelectionActions.setProductMemory(response));

      // ✅ pass response to cb
      if (cb) yield call(cb, null, response);
    } else {
      // handle error
      if (cb) yield call(cb, new Error("No response received"), null);
    }
  } catch (err) {
    yield put(authActions.finishLoading());
    if (cb) yield call(cb, err, null);
  }
}
